import { render, staticRenderFns } from "./swiperWrapper.vue?vue&type=template&id=2e7f57db&scoped=true"
import script from "./swiperWrapper.vue?vue&type=script&lang=js"
export * from "./swiperWrapper.vue?vue&type=script&lang=js"
import style0 from "./swiperWrapper.vue?vue&type=style&index=0&id=2e7f57db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7f57db",
  null
  
)

export default component.exports